@if (isEmpty()) {
  <div class="topo-empty">
    This topology has no nodes yet. Use <strong>Edit</strong> to draw the network.
  </div>
} @else {
  <div class="topo-zoom">
    <button type="button" title="Zoom in" [disabled]="!canZoomIn()" (click)="zoomIn()">+</button>
    <button type="button" title="Zoom out" [disabled]="!canZoomOut()" (click)="zoomOut()">−</button>
    <button type="button" title="Fit" [disabled]="!canZoomOut()" (click)="resetZoom()">⤢</button>
  </div>

  <div class="topo-viewport vg-scroll">
    <svg
      class="topology"
      [attr.viewBox]="viewBox"
      preserveAspectRatio="xMidYMid meet"
      [style.width.%]="zoom() * 100"
      [style.height.%]="zoom() * 100"
    >
      <!-- Links between nodes -->
      @for (edge of edges(); track edge.key) {
        <line
          class="edge"
          [class.compromised]="edge.impact === 'compromised'"
          [class.exposed]="edge.impact === 'exposed'"
          [attr.x1]="edge.x1"
          [attr.y1]="edge.y1"
          [attr.x2]="edge.x2"
          [attr.y2]="edge.y2"
        >
          @if (edge.proto) {
            <title>{{ edge.key }} · {{ edge.proto }}</title>
          }
        </line>
      }

      <!-- Terminal devices hanging off a node -->
      @for (leaf of leaves(); track leaf.key) {
        <g class="leaf" [class.flagged]="leaf.flagged" [class.selected]="leaf.selected">
          <line class="leaf-edge" [attr.x1]="leaf.px" [attr.y1]="leaf.py" [attr.x2]="leaf.cx" [attr.y2]="leaf.cy" />
          <circle [attr.cx]="leaf.cx" [attr.cy]="leaf.cy" [attr.r]="leafR" />
          <text class="leaf-label" [attr.x]="leaf.cx" [attr.y]="leaf.cy + 3.2">{{ leaf.label }}</text>
        </g>
      }

      <!-- Nodes -->
      @for (node of nodes(); track node.id) {
        <g
          class="node"
          [class]="'kind-' + node.kind"
          [class.flagged]="node.flagged"
          [class.selected]="node.selected"
        >
          <title>{{ node.label }}{{ node.sub ? ' · ' + node.sub : '' }}</title>

          <!--
            Outside the halo, so a device that is both wrong and being read shows both without the
            two touching. Static and cyan on purpose: this says "you are looking at this", not
            "this is on fire".
          -->
          @if (node.selected) {
            <rect
              class="ring"
              [attr.x]="node.x - 2.6"
              [attr.y]="node.y - 2.6"
              [attr.width]="node.w + 5.2"
              [attr.height]="node.h + 5.2"
              rx="2.6"
            />
          }

          @if (node.flagged) {
            <rect
              class="halo"
              [attr.x]="node.x - 1.4"
              [attr.y]="node.y - 1.4"
              [attr.width]="node.w + 2.8"
              [attr.height]="node.h + 2.8"
              rx="2"
            />
          }

          <rect
            class="box"
            [attr.x]="node.x"
            [attr.y]="node.y"
            [attr.width]="node.w"
            [attr.height]="node.h"
            rx="1.2"
          />
          <text class="node-label" [attr.x]="node.cx" [attr.y]="node.firstLineY">
            @for (line of node.lines; track $index) {
              <tspan [attr.x]="node.cx" [attr.dy]="$index === 0 ? 0 : lineH">{{ line }}</tspan>
            }
          </text>

          @if (node.sub) {
            <text class="node-sub" [attr.x]="node.cx" [attr.y]="node.subY">{{ node.sub }}</text>
          }

          @if (node.spark) {
            <polyline class="spark" [attr.points]="node.spark" />
          }
          @if (node.latest !== null) {
            <text class="node-metric" [attr.x]="node.cx" [attr.y]="node.metricY">
              {{ node.latest }}
            </text>
          }
        </g>
      }
    </svg>
  </div>
}
